import { useTranslation } from '@crew/modules/i18n'
import BaseOutlineVideocam from '~icons/ic/outline-videocam'
import { FC, memo, useCallback } from 'react'
import { CrewButton } from 'components/elements/crewButton/crewButton'
import { useModal } from 'components/layouts/modal/useModal'
import { EventSearch } from './components/eventSearch/eventSearch'
import { EventScheduleEntryDialog } from '../eventScheduleEntryDialog/eventScheduleEntryDialog'

export const EventListToolbar: FC = memo(() => {
  const { t } = useTranslation()

  // イベント登録ダイアログ
  const [isEventEntryDialogOpen, openEventEntryDialog, closeEventEntryDialog] =
    useModal()

  // handle open new event modal
  const handleOpenNewEventModal = useCallback(() => {
    openEventEntryDialog()
  }, [openEventEntryDialog])

  // Register event finish
  const handleEventRegistered = useCallback(() => {
    // Close entry dialog
    closeEventEntryDialog()
  }, [closeEventEntryDialog])

  return (
    <div className="flex flex-col gap-2.5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1 crew-text-gray-4">
          <BaseOutlineVideocam width={24} height={24} />
          <p>{t('label.meeting')}</p>
        </div>

        {/* 新規会議 */}
        <CrewButton
          id="event-list-toolbar-new-event-button"
          type="primary"
          onClick={handleOpenNewEventModal}
          text={t('action.newMeeting')}
        />
      </div>
      <EventSearch />
      {/* Event new schedule */}
      <EventScheduleEntryDialog
        isEditMode={false}
        title={t('label.registerNewSchedule')}
        isOpen={isEventEntryDialogOpen}
        onClose={closeEventEntryDialog}
        onSubmit={handleEventRegistered}
      />
    </div>
  )
})
